export const lensAddresses = {
  accountLens: "0x946b7EBF76579A746b8Db0EbdbCaD3b67e01F497",
  eulerEarnVaultLens: "0xa97E26fDF7d6A7efC31f30653DAbeec6c5884960",
  irmLens: "0x1bb793634de85320AC7cAF8E45b935e47C3C70bD",
  oracleLens: "0x8dc4004FD955bfb2E17Bdd0EdCB6F02623Bed92E",
  utilsLens: "0x153B8d05e6DC36168d9FcD31Cd68a5f87ff3cB28",
  vaultLens: "0x8767dfc819f29Da48c6d56b9858596C3B2d4f253",
} as const
